import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Modal,
  Input,
  Space,
  Select,
  Switch,
} from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  SearchOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import axios from 'axios'

import {
  CreateTermsConditionMaster,
  DeleteTermsConditionMaster,
  GetTermsConditionMaster,
  UpdateTermsConditionMaster,
} from '../../../AllAPI/AdminAPI'

import { toast } from 'react-toastify'

const TermsAndConditionMaster = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  // useState inputs
  const [serialNo, setSerialNo] = useState('')
  const [description, setDescription] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [editingId, setEditingId] = useState(null)

  useEffect(() => {
    fetchTermsConditions()
  }, [])


  // Load Terms & Condition
  const fetchTermsConditions = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${GetTermsConditionMaster}/${storedBranchId}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.id,
        index: index + 1,
        serial_no: item.serial_no,
        description: item.description,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load Fee Amount')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // Open modal for Add/Edit
  const handleOpenModal = (record = null) => {
    if (record) {
      setEditingId(record.key)
      setSerialNo(record.serial_no)
      setDescription(record.description)
    } else {
      setEditingId(null)
      setSerialNo('')
      setDescription('')
    }
    setIsModalOpen(true)
  }

  // Save / Update
  const handleSave = async () => {
    if (!serialNo) return toast.error('Please select a serial no.')
    if (!description.trim()) return toast.error('Please enter Terms Condition ')

    const payloadUpdate = {
      serial_no: serialNo,
      description: description,
      branch_id: storedBranchId,
    }
    const payloadCreate = {
      serial_no: serialNo,
      description: description,
      branch_id: storedBranchId,
    }

    try {
      if (editingId) {
        const res = await axios.put(
          `${UpdateTermsConditionMaster}/${editingId}`,
          payloadUpdate,
        )
        if (res.data === 'UPDATED') {
          toast.success('Terms Condition  updated successfully')
        } else if (res.data === 'EXIST') {
          toast.warn('Already Exist!')
        }
      } else {
        const res = await axios.post(`${CreateTermsConditionMaster}`, payloadCreate)
        if (res.data === 'SAVED') {
          toast.success('Terms Condition  added successfully')
          fetchTermsConditions()
          setIsModalOpen(false)
          setEditingId(null)
          setSerialNo('')
          setDescription('')
        } else if (res.data === 'ALREADYEXIST') {
          toast.warn('Already Exist!')
        } else if (res.data === 'INVALIDAMOUNT') {
          toast.warn('Invalid Terms Condition !')
        }
      }

    } catch (err) {
      toast.error('Failed to save Terms Condition ')
    }
  }

  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(`${DeleteTermsConditionMaster}/${id}`)
      if (res.data === 'NOTFOUND') {
        toast.warn('Terms Condition not found!')
        fetchTermsConditions()
      } else if (res.data === 'DELETED') {
        toast.success('Terms Condition  deleted successfully')
        fetchTermsConditions()
      }
    } catch (err) {
      toast.error('Failed to delete Terms Condition ')
    }
  }

  const openDeleteModal = (id) => {
    setDeleteId(id)
    setIsDeleteModalOpen(true)
  }

  const confirmDelete = async () => {
    await handleDelete(deleteId)
    setIsDeleteModalOpen(false)
    setDeleteId(null)
  }

  // Search filter
  const filteredData = data.filter((item) =>
    (item.description + '').toLowerCase().includes(searchText.toLowerCase()),
  )

  const columns = [
    { title: 'Sr No', dataIndex: 'index' },
    { title: 'Serial No.', dataIndex: 'serial_no' },
    { title: 'Description', dataIndex: 'description' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleOpenModal(record)}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            size="small"
            onClick={() => openDeleteModal(record.key)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">

      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Terms And Condition Master</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search terms & conditions..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />

            <Button
              type="primary"
              className="mt-2 mt-md-0"
              icon={<PlusOutlined />}
              onClick={() => handleOpenModal()}
              style={{ marginLeft: 10 }}
            >
              Add Terms & Conditions
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* MODAL */}
      <Modal
        title={editingId ? 'Edit Terms & Condition' : 'Add Terms & Condition'}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSave}>
            Save
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 15 }}>
          <label>Serial No</label>
          <Input
            placeholder="Enter Serial No"
            min={0}
            value={serialNo}
            onChange={(e) => setSerialNo(e.target.value)}
            disabled={!!editingId}
          />
        </div>

        <div>
          <label>Description</label>
          <Input
            placeholder="Enter Description"
            min={0}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </Modal>

      {/* ===DELETE MODAL==== */}
      <Modal
        title="Confirm Delete"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsDeleteModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="delete" danger type="primary" onClick={confirmDelete}>
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to delete this terms & condition?</p>
      </Modal>
    </div>
  )
}

export default TermsAndConditionMaster
